import { setThemeColor } from '../../../utils/utils'

const h5Module = {
  namespaced: true, // 使用命名空间
  state: () => ({
    categoryDialogVisible: false // 类目弹窗
  }),
  mutations: {
    setCategoryDialogVisible (state, payload) {
      state.categoryDialogVisible = payload
      setThemeColor(payload ? '#141414' : '#052785')
    }
  },
  actions: {

  },
  getters: {
  }
}

export default h5Module
